import React from 'react';
import '../index.css';
import Pawn from '../pieces/pawn.js';
import Knight from '../pieces/knight';
import Board from './board.js';
import King from '../pieces/king'
import initialiseChessBoard from '../helpers/board-initialiser.js';


export default class Chressage extends React.Component {
  constructor() {
    super();
    this.state = {
      squares: initialiseChessBoard(),
      whiteFallenSoldiers: [],
      blackFallenSoldiers: [],
      player: 1,
      sourceSelection: -1,
      currentPosition: 49,
      status: '',
      turn: 'white'
    };
    this.cardsIdArray=[1,2,3,4,5];
    this.card1RestrictedArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 21, 23,31,39,47,55,63];
    this.card2RestrictedArray = [0, 1, 2, 3, 4, 5, 6, 7, 13, 14, 15, 21, 22, 23, 29, 30, 31, 37, 38, 39, 45, 46, 47, 53, 54, 55, 61, 62, 63];
    this.card3RestrictedArray = [0, 8, 16, 24, 32, 40, 48, 56, 67, 68, 59, 60, 61, 62, 63];
    this.card4RestrictedArray = [0, 1, 8, 9, 16, 17, 24, 25, 32, 33, 40, 41, 48, 49, 56, 57, 58, 59, 60, 61, 62, 63];
    this.card5RestrictedArray = [7, 15, 23, 31, 39, 47, 55, 63];
  }
  

  getNextPosition = (buttonId, currentPosition) => {

    var nextItemPosition = -1;

    if (buttonId === 1) {
      if (this.card1RestrictedArray.includes(currentPosition)) {
        this.props.failedMove();
      } else {
        nextItemPosition = currentPosition - 8 - 8 + 1;
      }
    } else if (buttonId === 2) {
      if (this.card2RestrictedArray.includes(currentPosition)) {
        this.props.failedMove();
      } else {
        nextItemPosition = currentPosition + 3 - 8;
      }
    } else if (buttonId === 3) {
      if (this.card3RestrictedArray.includes(currentPosition)) {
        this.props.failedMove();
      } else {
        nextItemPosition = currentPosition + 8 - 1;
      }
    } else if (buttonId === 4) {
      if (this.card4RestrictedArray.includes(currentPosition)) {
        this.props.failedMove();
      } else {
        nextItemPosition = currentPosition - 2 + 8;
      }

    } else if (buttonId === 5) {
      if (this.card5RestrictedArray.includes(currentPosition)) {
        this.props.failedMove();
      } else {
        nextItemPosition = currentPosition + 1;
      }
    }

    return nextItemPosition;
  }

  handleButtonClick = (args) => {
    
    const squares = [...this.state.squares];
    
    var currentItemPosition = this.state.currentPosition;
    var nextItemPosition = this.getNextPosition(args, currentItemPosition);

    // console.log("current and next:", currentItemPosition, nextItemPosition);
    if (nextItemPosition > 0 && nextItemPosition < 64) {
      // can move
    
      var index = this.cardsIdArray.indexOf(args);
      if (index !== -1) {
        this.cardsIdArray.splice(index, 1);
      };

      squares[nextItemPosition] = squares[currentItemPosition];
      squares[currentItemPosition] = null;
      
      if(nextItemPosition === 21){
        // alert("you win");
        if( this.cardsIdArray.length === 0 ){
          // complete game
          squares[21] = new Knight(1);
          
          //alert("You Win");
                   
          this.props.handleSucces();

        }else{
          squares[currentItemPosition] = null;
        }
      }else{
        squares[21] = new Pawn(2);
      }

      this.setState(oldState => ({
        sourceSelection: -1,
        currentPosition: nextItemPosition,
        squares,
        player: 1,
        status: '',
        turn: 'white'
      }));
    
    } else {
     
    }
  }


  handleClick(i) {
    return;
  }

  getKingPosition(squares, player) {
    return squares.reduce((acc, curr, i) =>
      acc || //King may be only one, if we had found it, returned his position
      ((curr //current squre mustn't be a null
        && (curr.getPlayer() === player)) //we are looking for aspecial king 
        && (curr instanceof King)
        && i), // returned position if all conditions are completed
      null)
  }

  isCheckForPlayer(squares, player) {
    const opponent = player === 1 ? 2 : 1
    const playersKingPosition = this.getKingPosition(squares, player)
    const canPieceKillPlayersKing = (piece, i) => piece.isMovePossible(playersKingPosition, i, squares)
    return squares.reduce((acc, curr, idx) =>
      acc ||
      (curr &&
        (curr.getPlayer() === opponent) &&
        canPieceKillPlayersKing(curr, idx)
        && true),
      false)
  }

  render() {
    const boardImg = "assets/chess-board.png";
    return (
      <div className='chessGameContainer'>
      <div className='gameBoardContainer'>
        <div className="game" style={{ backgroundImage: `url(${boardImg})` }}>
          <div className="game-board">
            <Board
              squares={this.state.squares}
              onClick={(i) => this.handleClick(i)}
            />
          </div>
        </div>
        
      </div>
      <div className='gameControlContainer'>
          <div className='card1' onClick={() => { this.handleButtonClick(1) }}></div>
          <div className='card2' onClick={() => { this.handleButtonClick(2) }}></div>
          <div className='card3' onClick={() => { this.handleButtonClick(3) }}></div>
          <div className='card4' onClick={() => { this.handleButtonClick(4) }}></div>
          <div className='card5' onClick={() => { this.handleButtonClick(5) }}></div>
        </div>
</div>
    );
  }
}

